import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import close from "../images/hireDeveloper/close.svg";
import { Box, Step, StepLabel, Stepper } from "@mui/material";
import Userinfo from "../component/gethiredeveloper/userinfo";
import Userskill from "../component/gethiredeveloper/userskill";
import UserExperience from "../component/gethiredeveloper/userExperience";
import Uploadcv from "../component/gethiredeveloper/uploadcv";
import Internationalclients from "../component/gethiredeveloper/internationalclients";
import Compensation from "../component/gethiredeveloper/compensation";
import Candidatedetails from "../component/gethiredeveloper/candidatedetails";
import Modal from "react-modal";
import jobApplied from "../images/hireDeveloper/jobApplied.svg";
import axios from "axios";
import {
  getSkillData,
  userexperience,
} from "../component/gethiredeveloper/getconstdata";
import config from "../config";

const steps = [
  "Your Information",
  "Choose The Job Roles You Are Looking To Apply For",
  "How Many Years Of Experience Do You Have?",
  "Upload Your Resume",
  "Experience With Working Directly With International Clients?",
  "Current Compensation Range",
];

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: "99999",
  },
};

const GetHireDeveloper = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [getPageData, setGetPageData] = useState({
    userinfo: "",
    userskill: [],
    getAnotherSkill: "",
    userexperience: "less3",
    uploadcv: { name: "No file chosen...", path: "" },
    nightShift: "",
    internationalclients: "yes",
    compensation: "",
  });
  useEffect(() => {
    document.body.className = "lightBG";
  }, []);

  const isValid = () => {
    switch (activeStep) {
      case 0:
        const emailTest = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (
          getPageData.userinfo.name &&
          emailTest.test(getPageData.userinfo.email)
        )
          return true;
        else return false;
      case 1:
        if (getPageData.userskill.includes(10)) {
          return Boolean(getPageData.getAnotherSkill);
        } else return getPageData.userskill.length ? true : false;
      case 3:
        if (getPageData.uploadcv.type) return true;
        else return false;
      case 5:
        if (getPageData.compensation) return true;
        else return false;
      default:
        return true;
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    if ((prevActiveStep) => prevActiveStep <= 5) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const saveData = (id, value) => {
    setGetPageData({ ...getPageData, [id]: value });
  };

  const [modalIsOpen, setIsOpen] = React.useState(false);

  const openModal = async () => {
    const filterSkill = getSkillData
      .filter((s) => getPageData.userskill.includes(s.id))
      .map((_s) => _s.name);
    const filterExp = userexperience.find(
      (e) => getPageData.userexperience === e.value
    ).label;
    if (getPageData.uploadcv.size) {
      var file = getPageData.uploadcv.baseFile;
    }
    const employeeData = {
      ...getPageData,
      userskill: filterSkill,
      uploadcv: { file },
      userexperience: filterExp,
    };
    /*here before*/
    await axios.post(`${config.baseUrl}/hireemployee`, employeeData);
    setIsOpen(true);
    document.body.className = "lightBG reactModel";
  };

  const history = useNavigate();

  const closeModal = () => {
    setIsOpen(false);
    document.body.className = "lightBG";
    history("/GetHire");
  };

  return (
    <>
      <div className="getHireMainSection">
        <section className="getHireHeader">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2>Apply For Remote Job</h2>
                <Link to="/GetHire" className="close">
                  <img src={close} alt="Hire NodeJS Developers" />
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section
          className={
            activeStep === 6
              ? "getProgressSection d-none"
              : "getProgressSection"
          }
        >
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <Box sx={{ width: "100%" }} className="progressBar">
                  <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel className="progressLabel" title={label}>
                          {label}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              </div>
            </div>
          </div>
        </section>

        {activeStep === 0 ? (
          <Userinfo getData={getPageData.userinfo} getOnSave={saveData} />
        ) : null}
        {activeStep === 1 ? (
          <Userskill
            getData={getPageData.userskill}
            getOnSave={saveData}
            getAnotherSkill={getPageData.getAnotherSkill}
          />
        ) : null}
        {activeStep === 2 ? (
          <UserExperience
            getData={getPageData.userexperience}
            getOnSave={saveData}
          />
        ) : null}
        {activeStep === 3 ? (
          <Uploadcv
            getData={getPageData.uploadcv}
            getOnSave={saveData}
            nightShift={getPageData.nightShift}
          />
        ) : null}
        {activeStep === 4 ? (
          <Internationalclients
            getData={getPageData.internationalclients}
            getOnSave={saveData}
          />
        ) : null}
        {activeStep === 5 ? (
          <Compensation
            getData={getPageData.compensation}
            getOnSave={saveData}
          />
        ) : null}
        {activeStep === 6 ? <Candidatedetails getData={getPageData} /> : null}

        <section className="getProcessBtn">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <button onClick={handleBack} disabled={activeStep === 0}>
                  <span>Back</span>
                </button>
                {activeStep === 6 ? (
                  <button onClick={openModal}>
                    <span>Finish</span>
                  </button>
                ) : (
                  <button disabled={!isValid()} onClick={handleNext}>
                    <span>Next</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal
        isOpen={modalIsOpen}
        style={customStyles}
        contentLabel="JobApply Modal"
        ariaHideApp={false}
      >
        <img src={jobApplied} alt="Hire Dadicated NodeJS Developer" />
        <h4>Thank you for your Interest!</h4>
        <p>Our hr will contact you sortly!</p>
        <a className="btn" onClick={closeModal}>
          <span>Close</span>
        </a>
      </Modal>
    </>
  );
};

export default GetHireDeveloper;
